import $ from "../core/jquery-global";

export function initPageLoader() {
    setTimeout(function () {
        $(".nav").removeClass("is_fading");
        $(".site").removeClass("is_fading");
    }, 150);

    setTimeout(function () {
        $(".loading-overlay--primary").addClass("is_animated_down");
    }, 300);

    $(document).on("click", ".js-outbound-link", function (e) {
        var $link = $(this);
        var ww = $(window).width();

        if (ww <= 1024 && $link.hasClass("js_mobileOpen")) {
            e.preventDefault();
            return;
        }

        var url = $link.attr("href");

        if (!url || url === "#") {
            return;
        }

        e.preventDefault();

        $(".loading-overlay--secondary").removeClass("is_animated_up");

        setTimeout(function () {
            window.location.href = url;
        }, 100);
    });
}
